import React from 'react';
import {
  StyledLabel,
  StyledInput,
  StyledInputFacade,
  StyledText,
} from './styles';
import { useTruncationTooltip } from '../Tooltip';

const RadioButton = ({
  hover,
  error = false,
  disabled = false,
  checked = false,
  onChange,
  value,
  label,
  name,
  className = '',
  size = 'medium',
  dataQa,
}) => {
  const [tooltipProps, tooltip] = useTruncationTooltip();
  const dataQaProps = dataQa ? { 'data-qa-id': dataQa } : null;
  return (
    <StyledLabel size={size} className={className}>
      <StyledInput
        type="radio"
        error={error}
        disabled={disabled}
        checked={checked}
        onChange={() => onChange(value)}
        value={value}
        name={name}
        size={size}
        {...dataQaProps}
      />
      <StyledInputFacade size={size} error={error} />
      {tooltip}
      <StyledText disabled={disabled} error={error} {...tooltipProps}>
        {label}
      </StyledText>
    </StyledLabel>
  );
};

export default RadioButton;
